import React from "react";
import { HelpTooltip } from "../HelpTooltip";

const TOOLTIP_HELP_CONTENT = "If an answer is retained, the user's response for this matching round will be carried over to future rounds. Once the user registers for a future round, they will have the option to update their answer if desired.";

interface IProps {
  children: React.ReactNode;  
}

export const RetainAnswerHelpTooltip: React.FC<IProps> = (props) => {
  return <HelpTooltip text={TOOLTIP_HELP_CONTENT}>{props.children}</HelpTooltip>;
};